import { render, staticRenderFns } from "./VlAddActionsModal.vue?vue&type=template&id=6767e930&scoped=true&"
import script from "./VlAddActionsModal.vue?vue&type=script&lang=js&"
export * from "./VlAddActionsModal.vue?vue&type=script&lang=js&"
import style0 from "./VlAddActionsModal.vue?vue&type=style&index=0&id=6767e930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6767e930",
  null
  
)

export default component.exports